export enum ItemSizeEnum {
  ONE_COLUMN = "ONE_COLUMN",
  ONE_COLUMN_ICON = "ONE_COLUMN_ICON",
  ONE_COLUMN_IMAGE = "ONE_COLUMN_IMAGE",
  TWO_COLUMNS = "TWO_COLUMNS",
  TWO_COLUMNS_ICONS = "TWO_COLUMNS_ICONS",
  TWO_COLUMNS_IMAGES = "TWO_COLUMNS_IMAGES",
  TWO_COLUMNS_IMAGES_TRANSPARENT = "TWO_COLUMNS_IMAGES_TRANSPARENT",
}
